import { emitPageView } from 'store/userEnvironment/userEnvironmentActions';
import { createPageViewEvent } from '../eventCreators';
import { createPageViewEventPayload } from '../dataHelpers/createPageViewEventPayload';
import { isEmpty } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export const qffHashIdCheck = (payload) => {
  if (typeof window !== 'undefined') {
    if (!isEmpty(payload.qf_value)) {
      localStorage.removeItem('savedQffHashId');
      localStorage.setItem('savedQffHashId', payload.qf_value);
      return payload.qf_value;
    }
    const savedQffHashId = localStorage.getItem('savedQffHashId');
    if (savedQffHashId) {
      return savedQffHashId;
    } else {
      const newQffHashId = uuidv4();
      localStorage.setItem('savedQffHashId', newQffHashId);
      return newQffHashId;
    }
  }
};

const emitPageViewEvent = ({ payload }) => {
  const qffHashId = qffHashIdCheck(payload);
  const qffPoints = Number(payload.qffPoints.toString());
  const pageViewEvent = createPageViewEvent(
    createPageViewEventPayload({
      pageType: payload.pageType,
      pageTitle: document.title,
      location: location.href,
      referrer: document.referrer,
      siteId: 'hotels',
      siteVertical: 'travel',
      user: {
        isLoggedIn: payload.isLoggedIn,
        ...(payload.isLoggedIn && {
          userId: qffHashId,
          qffHashId: qffHashId,
          qffPoints,
        }),
        ...(!payload.isLoggedIn && {
          userId: '',
          qffHashId: qffHashId,
        }),
      },
    }),
  );
  return pageViewEvent;
};

export default { [emitPageView]: emitPageViewEvent };
